<template>
  <div>
    <Modal v-if="type == 'widget'"></Modal>

    <div v-if="this.flight && type == 'frame'"
      :class="`flex-display seat-selector seat-selector-${type} ${(this.isVisible ? 'is--visible' : '')} ${locale}`">


      <div class="seat-selector-frame--content" :style="{
        '--bgColor2': style.bgColor2,
        '--bgColor3': style.bgColor3
      }
        ">


        <div  class="travel--info" :style="{
          '--bgColor1': style.bgColor1,
          '--fontColor1': style.fontColor1
        }">
          <div @click="toggleSelector" class="close--widget" v-if="type == 'widget'">
            <i class="icon-cross"></i>
          </div>
          <FlightSelector :type="type" />
          <Passengers :type="type" />
        </div>




        <div  class="plane-legend-content">
          <Legend v-if="mobileLegendOnTop" />
          <div class="content-plane">
            <div class="plane-frame" v-if="flight.seatmap">
              <ColumnList :columns="flight.seatlayout" />
              <RowList v-for="(row, index) in flight.seatmap" :key="index" :flightid="flight.id" :row="row"
                :seatCountOnRow="seatCountOnRow" :priceMap="priceMap" :text="text" :styling="style" />
            </div>
          </div>
          <div class="seat-map-not-available" v-if="!flight.seatmap">
            <div>
              <img :src="`${style.not_available_seat_selection_image}`" class="seat-map-not-available-image" />
            </div>
            <div>
              <div class="llegend-seatmap-not-available">
                <h6 class="seatmap-not-available-title">
                  {{ text.sorry }}
                </h6>
                <p class="seatmap-not-available-info"> {{ text.seat_selection_is_not_available }}</p>
              </div>
            </div>

          </div>
          <Legend v-if="!mobileLegendOnTop" />
        </div>


        <div class="recap--info" :style="{
          '--bgColor1': style.bgColor1,
          '--fontColor1': style.fontColor1,
          '--fontColor2': style.fontColor2,
          '--fontColor3': style.fontColor3,
          '--fontFamily': style.fontFamily,
          '--passengerSelectedColor': style.passengerSelectedColor,
          '--passengerSelectedFontColor': style.passengerSelectedFontColor,
        }">

        <LegendModal v-show="showLegendModal" @close="showLegendModal = false;" />

        <div class="sticky-seat-information">
          <button type="button" id="show-modal" @click="showLegendModal = !showLegendModal">{{ text.seat_information }}</button>
        </div>


          <!-- <div v-if="showLegendModal">
            <button data-seat-selected-remove  @click="showLegendModal = false">{{ text.close }}</button>
          </div> -->

          <div @click="showLegendModal = false;">
            <span>{{ text.total }} {{ formatCurrency(bookingTotals.cost) }}</span>
            <button data-seat-selected-confirm v-if="nextFlightId" @click="nextFlight(false)">{{ text.next }}</button>
            <button data-seat-selected-confirm v-else-if="isComplete" @click="complete">{{ text.confirm }}</button>
            <button data-seat-selected-remove v-else @click="complete">{{ text.skip }}</button>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="`seat-selector seat-selector-${type ? type : 'frame'} ${(this.isVisible ? 'is--visible' : '')} ${locale}`"
      v-if="this.flight && type == 'widget'">
      <div class="seat-selector-widget--content" :style="{
        '--bgColor2': style.bgColor2,
        '--bgColor3': style.bgColor3
      }
        ">
        <div class="travel--info" :style="{
          '--bgColor1': style.bgColor1,
          '--fontColor1': style.fontColor1
        }">
          <div @click="toggleSelector" class="close--widget" v-if="type == 'widget'">
            <i class="icon-cross"></i>
          </div>
          <FlightSelector :type="type" />
          <Passengers :type="type" />
        </div>
        <Legend v-if="mobileLegendOnTop" />
        <div class="content-plane">
          <div class="plane" v-if="flight.seatmap">
            <ColumnList :columns="flight.seatlayout" />
            <RowList v-for="(row, index) in flight.seatmap" :key="index" :flightid="flight.id" :row="row"
              :seatCountOnRow="seatCountOnRow" :priceMap="priceMap" :text="text" :styling="style" />
          </div>
        </div>
        <div class="seat-map-not-available" v-if="!flight.seatmap">
          <div>
            <img :src="`${style.not_available_seat_selection_image}`" class="seat-map-not-available-image" />
          </div>
          <div>
            <div class="llegend-seatmap-not-available">
              <h6 class="seatmap-not-available-title">
                {{ text.sorry }}
              </h6>
              <p class="seatmap-not-available-info"> {{ text.seat_selection_is_not_available }}</p>
            </div>
          </div>

        </div>
        <Legend v-if="!mobileLegendOnTop" />

        <div class="recap--info" :style="{
          '--bgColor1': style.bgColor1,
          '--fontColor1': style.fontColor1,
          '--fontColor2': style.fontColor2,
          '--fontColor3': style.fontColor3,
          '--fontFamily': style.fontFamily,
          '--passengerSelectedColor': style.passengerSelectedColor,
          '--passengerSelectedFontColor': style.passengerSelectedFontColor,
        }">
          <span>{{ text.total }} {{ formatCurrency(bookingTotals.cost) }}</span>
          <button data-seat-selected-confirm v-if="nextFlightId" @click="nextFlight(false)">{{ text.next }}</button>
          <button data-seat-selected-confirm v-else-if="isComplete" @click="complete">{{ text.confirm }}</button>
          <button data-seat-selected-remove v-else @click="complete">{{ text.skip }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'

import Passengers from './Header/Passengers'
import FlightSelector from './Header/FlightSelector'

import RowList from './RowList'
import ColumnList from './ColumnList'
import Legend from './Legend'
import Modal from './Modal'
import LegendModal from './LegendModal.vue'

export default {
  beforeUpdate() {
    // console.log('[Benchmark]' + this.$options._componentTag + ' beforeUpdate ')
    // this.start = Date.now()
  },

  updated() {
    // let now = Date.now()
    // let passed = (now - this.start) / 1000
    //
    // console.log('[Benchmark]' + this.$options._componentTag + ' updated in ' + passed + 's')

    setTimeout(() => {
    this.setLoading(false)
    }, 500)
  },
  props: ['token', 'type', 'env', 'config'],
  components: {
    Passengers,
    RowList,
    FlightSelector,
    ColumnList,
    Legend,
    Modal,
    LegendModal
  },

  data() {
    return {
      aggregateToken: null,
      showLegendModal: false
    }
  },

  methods: {
    ...mapActions(['loadData', 'toggleSelector', 'complete', 'nextFlight', 'setLoading']),
    init(init) {
      this.loadData({ init: init, token: this.aggregateToken, type: this.type, env: this.env, config: JSON.parse(this.config) })
      // console.log('Core (re) init')
    }
  },
  mounted() {
    this.aggregateToken = (this.type === 'widget') ? this.token : this.token, //new URL(window.location.href).searchParams.get('token')
    this.init(true)
  },
  watch: {
    isVisible(is, was) {
      if (was && !is) {
        // console.log('isVisible watch')
        setTimeout(() => {
          if (!this.confirming) {
            this.init(false)
          }
        }, 100)
      }
    },
    confirming(value, oldValue) {
      if (!value && oldValue) {
        // console.log('confirmed')
        setTimeout(() => {
          this.init(false)
        }, 100)
      }
    }
  },

  computed: {
    ...mapGetters(['flight', 'bookingTotals', 'isComplete', 'style', 'text', 'formatCurrency', 'iconFont', 'seatCountOnRow', 'priceMap', 'text', 'style', 'nextFlightId', 'locale']),
    ...mapState(['isVisible', 'confirming', 'autoChangeFlight', 'loading', 'mobileLegendOnTop'])
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i&display=swap');

body {
  margin: 0;
}

#ss-container .close--widget .icon-cross {
  font-size: 19px;
  font-weight: bold;
  cursor: pointer;
}

#ss-container .seat-selector-widget {
  background-color: rgba(0, 0, 0, .75);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: all 200ms cubic-bezier(.645, .045, .355, 1);
}

#ss-container .seat-selector-frame {
  /* position: fixed;
  top: 0;
  right: 0;
  bottom: 0; */
  /* width: 100%;
  max-width: 810px; */
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  /*transition: all 800ms cubic-bezier(.645, .045, .355, 1);*/
}

#ss-container .seat-selector.is--visible {
  transition: all 200ms cubic-bezier(.645, .045, .355, 1);
  opacity: 1;
  visibility: visible;
}

#ss-container .seat-selector-widget--content {
  display: none;
  background-color: var(--bgColor2);
  width: calc(100% - 6rem);
  max-width: calc(810px - 6rem);
  position: absolute;
  left: 50%;
  margin-left: calc((810px - 4rem) / 2 * -1);
  top: 30px;
  bottom: 30px;
  overflow-y: scroll;
  padding: 3rem;
  transition: all 500ms cubic-bezier(.645, .045, .355, 1);
}

#ss-container .seat-selector.is--visible .seat-selector-widget--content {
  transition: all 500ms cubic-bezier(.645, .045, .355, 1);
  display: block;
}


#ss-container .seat-selector-widget--content .travel--info {
  position: fixed;
  top: 30px;
  left: 50%;
  margin-left: calc((810px - 4rem) / 2 * -1);
  width: calc(100% - 4rem);
  max-width: calc(810px - 4rem);
  height: calc(140px - 2rem);
  background-color: var(--bgColor1);
  border-bottom: 1px solid var(--fontColor1);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, .1);
  z-index: 99;
  padding: 1rem 2rem;
  -ms-align-items: center;
  align-items: center;
  justify-content: space-between;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
  transition: all 500ms cubic-bezier(.645, .045, .355, 1);
}

#ss-container .seat-selector.is--visible .seat-selector-widget--content .travel--info {
  transition: all 500ms cubic-bezier(.645, .045, .355, 1);
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}

#ss-container .seat-selector.is--visible .seat-selector-frame--content .travel--info {
  /* position: fixed; */
  top: 30px;
  /* left: 50%; */
  /* margin-left: calc((810px - 4rem) / 2 * -1); */
  /* width: 100%; */
  max-width: 100%;
  height: max-content;
  background-color: var(--bgColor1);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, .1);
  z-index: 99;
  -ms-align-items: center;
  align-items: center;
  display: flex;
  justify-content: start;
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
  transition: all 500ms cubic-bezier(.645, .045, .355, 1);
  border: solid 1px var(--fontColor1);
}

.travel--info .air--route-frame:first-child{
  border-right: solid 1px var(--fontColor1);
  justify-content: right;
}

#ss-container .seat-selector .seat-selector-frame--content .travel--info {
  height: 0;
  padding: 0;
}

#ss-container .plane {
  width: 100%;
  max-width: 325px;
  background-color: #FFFFFF;
  border-left: 2px solid #CDCECF;
  border-right: 2px solid #CDCECF;
  position: relative;
  z-index: 2;
  margin: 50px auto 50px;
  padding-top: 100px;
  border-top: 2px solid #CDCECF;
  border-top-left-radius: 150px;
  border-top-right-radius: 150px;
  border-bottom: 2px solid #CDCECF;
  padding-bottom: 100px !important;
}


#ss-container .plane-frame{
  width: 100%;
  max-width: 320px;
  background-color: #FFFFFF;
  /* border-left: 2px solid #CDCECF;
  border-right: 2px solid #CDCECF; */
  position: relative;
  z-index: 2;
  margin: 0;
  margin-top: 5px;
  padding: 20px 5px;
  /* border-top: 2px solid #CDCECF;
  border-top-left-radius: 150px;
  border-top-right-radius: 150px;
  border-bottom: 2px solid #CDCECF; */
  padding-bottom: 100px !important;
}

#ss-container .seat-selector-widget--content .recap--info {
  position: fixed;
  bottom: 30px;
  left: 50%;
  margin-left: calc((810px - 4rem) / 2 * -1);
  padding: 1rem 2rem;
  width: calc(100% - 4rem);
  max-width: calc(810px - 4rem);
  height: calc(80px - 2rem);
  background-color: var(--bgColor1);
  border-top: 1px solid var(--fontColor1);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, .1);
  z-index: 99;
  display: none;
  -ms-align-items: center;
  align-items: center;
  justify-content: space-between;
  font-family: var(--fontFamily);
  color: var(--fontColor2);
  transition: all 500ms cubic-bezier(.645, .045, .355, 1);
}

#ss-container .seat-selector.is--visible .seat-selector-widget--content .recap--info {
  transition: all 500ms cubic-bezier(.645, .045, .355, 1);
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  font-size: 18px;
  font-weight: 600;
}

#ss-container .seat-selector-widget--content .recap--info button {
  cursor: pointer;
  background-color: var(--passengerSelectedColor);
  border-radius: 2px;
  color: var(--passengerSelectedFontColor);
  box-shadow: none;
  border: 0;
  height: 40px;
  font-size: 16px;
  width: 165px;
  width: fit-content;
}

#ss-container .seat-selector-widget--content .recap--info button.is--disabled {
  background-color: var(--bgColor3);
  color: var(--fontColor1);
  cursor: not-allowed;
}

.ss-loading {
  z-index: 999;
  background-color: var(--bgColor1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}


/*Medium devices (tablets, 768px and up)*/
@media (min-width: 768px) {
  #ss-container .seat-selector-widget--content .plane {
    margin: 0 0 50px;
    float: left;
  }

  #ss-container .seat-selector-widget--content .recap--info {
    justify-content: flex-end;
  }

  #ss-container .seat-selector-widget--content .recap--info button {
    margin-left: 15px;
  }

    #ss-container .seat-selector-frame--content .recap--info .sticky-seat-information{
    display: none;
  }
}

/*Large devices (desktops, 992px and up)*/
@media (min-width: 992px) {}

/*Extra large devices (large desktops, 1200px and up)*/
@media (min-width: 1200px) {}

@media only screen and (max-width: 768px) {

  /* For mobile phones: */
  #ss-container .seat-selector-widget--content,
  #ss-container .seat-selector-widget--content .travel--info,
  #ss-container .seat-selector-widget--content .recap--info,
  .ss-loading {
    margin-left: 0;
    left: 0;
  }
}

/* Absolute Center Spinner */
.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}

.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: var(--passengerSelectedColor);
  margin: -4px 0 0 -4px;
}

.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}

.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}

.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}

.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}

.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}

.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}

.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}

.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}

.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}

.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}

.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}

.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}

.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}

.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}

.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}

.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}

@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Hebrew language support */
.he .legend h6 {
  text-align: right;
}

.he .seat-selection--modal-body {
  text-align: right;
}

.he .legend .legend--item-container .legend--single-item {
  justify-content: space-between !important;
}

.he .legend .legend--item-container .legend--single-item .info {
  align-items: end !important;
}


#ss-container .seat-map-not-available {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  border: none
}


#ss-container .seat-map-not-available img {
  max-width: 300px;
}

#ss-container .seat-map-not-available h6 {
  font-size: 18px;
  margin: 0;
  margin-bottom: 20px;
  font-family: var(--fontFamily);
}

#ss-container .seat-map-not-available>* {
  flex: 1 0 50%;
}

@media (max-width: 768px) {
  #ss-container .seat-map-not-available {
    /* padding-top: 100px; */
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  #ss-container .seat-map-not-available img {
    margin-bottom: 20px;
  }

  #ss-container .seat-map-not-available>* {
    flex: 0;
  }

  #ss-container .seat-selector.is--visible .seat-selector-frame--content .plane-legend-content{
    align-items: center !important;
  }
}

/* CSS for in path widget aka frame */

#ss-container .seat-selector.is--visible .seat-selector-frame--content {
  transition: all 500ms cubic-bezier(.645, .045, .355, 1);
  /* display: flex; */
}


#ss-container .seat-selector .seat-selector-frame--content .plane-legend-content {
  max-height: 0;
}

#ss-container .seat-selector.is--visible .seat-selector-frame--content .plane-legend-content {
  /* display: none; */
  display: flex;
  justify-content: center;
  align-items: start;
  max-height: 550px;
  overflow: scroll;
  padding: 0 100px;
}

#ss-container .seat-selector-frame--content .plane {
  /* max-width: 100%; */
}








#ss-container .seat-selector.is--visible .seat-selector-frame--content .recap--info {
  position: relative;
  bottom: 30px;
  /* left: 50%; */
  /* margin-left: calc((810px - 4rem) / 2 * -1); */
  padding: 1rem 2rem;
  /* width: 100%; */
  display: flex;
  /* max-width: calc(810px - 4rem); */
  height: calc(95px - 2rem);
  background-color: var(--bgColor1);
  border-top: 1px solid var(--fontColor1);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, .1);
  z-index: 99;
  /* display: none; */
  -ms-align-items: center;
  align-items: center;
  justify-content: right;
  font-family: var(--fontFamily);
  color: var(--fontColor2);
  transition: all 500ms cubic-bezier(.645, .045, .355, 1);
}

#ss-container .seat-selector .seat-selector-frame--content .recap--info {
  height: 0;
  padding: 0;
}



#ss-container .seat-selector.is--visible .seat-selector-frame--content .recap--info {
  transition: all 500ms cubic-bezier(.645, .045, .355, 1);
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  font-size: 18px;
  font-weight: 600;
}

#ss-container .seat-selector-frame--content .recap--info button {
  cursor: pointer;
  background-color: var(--passengerSelectedColor);
  border-radius: 2px;
  color: var(--passengerSelectedFontColor);
  box-shadow: none;
  border: 0;
  margin-left: 30px;
  height: 40px;
  font-size: 16px;
  width: 165px;
  width: fit-content;
}

#ss-container .seat-selector-frame--content .recap--info button.is--disabled {
  background-color: var(--bgColor3);
  color: var(--fontColor1);
  cursor: not-allowed;
}

#ss-container .seat-selector-frame--content .legend {
  margin: 0;
  margin-left: 30px;
  padding-bottom: 100px;
}

#ss-container .seat-selector-frame--content .recap--info .sticky-seat-information{
  position: absolute;
  left: 10px;
  margin-bottom: 150px;
  padding: 5px;
  z-index: 30;
}



 #ss-container .seat-selector-frame--content .recap--info .sticky-seat-information button {
  background-color: var(--bgColor1);
  color: var(--fontColor2);
  box-shadow: none;
  border: solid 1px var(--fontColor1);
  border-radius: 5px;
  font-size: 12px;
  font-weight: bold;
  padding: 10px;
  height: auto;
  margin: 0;
}

@media (max-width: 768px) {
  #ss-container .seat-selector.seat-selector-frame .seat-selector-frame--content .plane-legend-content{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 0 20px;
    padding-bottom: 80px;
    background-color: var(--bgColor3);
  }

  #ss-container > div > div > div > div.plane-legend-content > div.legend {
    display: none;
    padding-left: 0;
    margin-left: 0;
  }

  #ss-container .seat-selector.seat-selector-frame .seat-selector-frame--content .plane-legend-content {
    /* width: 100%; */
  }

  #ss-container .plane-frame{
    margin-top: 0;
    padding-bottom: 10px !important;
  }

  #ss-container .seat-selector-frame--content .legend{
    padding-bottom: 1rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Core.vue